import { useStore } from "app/stores";
import { observer } from "mobx-react";
import React, { memo } from "react";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import RegisterProductPopup from "./Popup/RegisterProductPopup";
import { Grid } from "@material-ui/core";
import ViewListIcon from "@material-ui/icons/ViewList";
import RegisterProductIndex from "./RegisterProduct/RegisterProductIndex";
import RegisterMedicalSupplyIndex from "./RegisterMedicalSupply/RegisterMedicalSupplyIndex";
import RegisterProductAdvicePopup from "./Popup/RegisterProductAdvicePopup";
import RegisterMedicalSupplyPopup from "./Popup/RegisterMedicalSupplyPopup";
import RegisterMedicalAdvicePopup from "./Popup/RegisterMedicalAdvicePopup";

const RegisterProductAndMedicalIndex = () => {
  const {
    initRegisterProduct,

    openUpdateProductAdvicePopup,
    openAddProductAdvicePopup,
    pagingRegisterProduct,
    dataRegisterProduct,
    handleCloseAddProductAdvicePopup,
    handleCloseUpdateProductAdvicePopup,
    saveOrUpdateProductAdvice,
    resetPopupStore,
    searchListProductAdvice,
    handleChangeFormSearchProductAdvice,
  } = useStore().patientManagementStore.registerProductStore;
  const {
    dataRegisterMedicalSupply,
    openAddMedicalSupplyAdvicePopup,
    openUpdateMedicalSupplyAdvicePopup,
    initRegisterMedicalSupply,
    handleCloseAddMedicalSupplyAdvicePopup,
    handleCloseUpdateMedicalSupplyAdvicePopup,
    saveOrUpdateMedicalSupplyAdvice,
    pagingRegisterMedicalSupplyOrder,
    printContent,
    handleSetPrintContent,
  } = useStore().patientManagementStore.registerMedicalSupplyStore;

  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");

  const { listVatPercent, initialPatient, customerSourceWalkIn } =
    useStore().patientManagementStore.patientGeneralStore;

  return (
    <section className="form-patient " style={{ margin: "4px" }}>
      <div style={{ backgroundColor: "#bdfff342" }}>
        <Grid container spacing={1}>
          <Grid xs={12}>
            <RegisterProductIndex />
          </Grid>
        </Grid>

        {/* popup drug */}

        {!!openUpdateProductAdvicePopup && (
          <RegisterProductPopup
            open={!!openUpdateProductAdvicePopup}
            handleClose={handleCloseUpdateProductAdvicePopup}
            onSubmit={async (values) => {
              await saveOrUpdateProductAdvice(values);
            }}
            initRegisterProduct={{
              ...initRegisterProduct,
              patientId,
            }}
            listVatPercent={listVatPercent}
            resetPopupStore={resetPopupStore}
          />
        )}

        {!!openAddProductAdvicePopup && (
          <RegisterProductAdvicePopup
            open={!!openAddProductAdvicePopup}
            handleClose={() => {
              handleCloseAddProductAdvicePopup();
              pagingRegisterProduct();
            }}
            dataRegisterProduct={dataRegisterProduct}
            patient={initialPatient?.patientInfo}
            onSubmit={handleChangeFormSearchProductAdvice}
            initialData={searchListProductAdvice}
            customerSourceWalkIn={customerSourceWalkIn}
          />
        )}

        {/* popup medical */}
        {!!openUpdateMedicalSupplyAdvicePopup && (
          <RegisterMedicalSupplyPopup
            open={!!openUpdateMedicalSupplyAdvicePopup}
            handleClose={handleCloseUpdateMedicalSupplyAdvicePopup}
            onSubmit={async (values) => {
              await saveOrUpdateMedicalSupplyAdvice(values);
            }}
            initRegisterMedicalSupply={{
              ...initRegisterMedicalSupply,
              patientId,
            }}
            listVatPercent={listVatPercent}
          />
        )}

        {!!openAddMedicalSupplyAdvicePopup && (
          <RegisterMedicalAdvicePopup
            open={!!openAddMedicalSupplyAdvicePopup}
            handleClose={() => {
              handleCloseAddMedicalSupplyAdvicePopup();
              pagingRegisterMedicalSupplyOrder();
            }}
            dataRegisterMedicalSupply={dataRegisterMedicalSupply}
          />
        )}
      </div>
    </section>
  );
};

export default memo(observer(RegisterProductAndMedicalIndex));
